import logger from 'utils/logger.util';

const L = logger('lsDel');

const lsDel = (key, options) => {
  try {
    if (!options?.quiet) L.debug(key, ':', null);
    return localStorage.removeItem(key);
  } catch (e) {
    L.warn('lsDel()', e);
    return null;
  }
};

export default lsDel;
